function shortNumberFormat(value) {
  if (value < 1000) {
    return value;
  }

  let magnitude = -1;
  while (value >= 1000) {
    magnitude += 1;
    value /= 1000;
  }
  let number_string = `${value}`;
  if (number_string.length > 4) {
    number_string = number_string.match(/\d*\.\d{1}/)[0];
  }
  return number_string + ["K", "M", "G", "T", "P"][magnitude];
}

export default shortNumberFormat;
